import * as React from 'react';
import { convertToMonetary } from 'utilities/util';
import Tooltip from 'components/tooltip';
import { IDivisionBreakdown } from 'views/job-costing/utils/CostAndRevenueHelpers';
import { ProfitabilityBreakdownModal } from './ProfitabilityBreakdownModal';

interface IProps {
    label: string,
    value?: string,
    actualValue?: string
}
interface IData {
    firstRow: IProps;
    secondRow: IProps;
    lastRow: IProps;
    isNftpRoeEnabled?: boolean;
    breakdown?: IDivisionBreakdown;
}
export const TotalStatusHeader = (props:IData) => {
    const [isBreakdownVisible, setBreakdownVisible] = React.useState(false);
    const showBreakdownLink = Boolean(props.breakdown && props.breakdown.rows.length > 0);
    const estimatedTotal = Number(props.firstRow.value) - Number(props.secondRow.value);
    const hasActuals = props.firstRow.actualValue !== undefined || props.secondRow.actualValue !== undefined;
    const actualTotal = hasActuals ? Number(props.firstRow.actualValue) - Number(props.secondRow.actualValue) : undefined;

    const getStatus = (total: number) => {
        if(total > 0.01){
            return <span className="state green" />
        }
        return <span className="state red" />
    }

    const formatValue = (value?: string) => props.lastRow.value ? value : convertToMonetary(value);

    const table = (
        <table className="status padding-right-large" id="TotalHeader">
            {props.isNftpRoeEnabled && hasActuals && (
                <thead>
                    <tr>
                        <td/>
                        <td className="align-text-right" id="header-estimated">
                            <Tooltip direction="left" content="Converted to USD using the SAP M‑rate valid on the job's creation date.">
                                <strong>Estimated in USD</strong>
                            </Tooltip>
                        </td>
                        <td className="align-text-right" id="header-actual">
                            <Tooltip direction="left" content="The USD amount displayed is an Indicative USD Value (derived using M rates of job creation date) and may differ from the actual USD posted in the financial system.">
                                <strong>Indicative value in USD</strong>
                            </Tooltip>
                        </td>
                        <td/>
                    </tr>
                </thead>
            )}
            <tbody>
            <tr>
                <td id="label-revenue">{props.firstRow.label}</td>
                <td className="align-text-right" id="total-revenue">{formatValue(props.firstRow.value)}</td>
                {props.isNftpRoeEnabled && hasActuals && <td className="align-text-right" id="actual-revenue">{formatValue(props.firstRow.actualValue)}</td>}
                <td/>
            </tr>
            <tr>
                <td id="label-cost">{props.secondRow.label}</td>
                <td className="align-text-right" id="total-cost">{formatValue(props.secondRow.value)}</td>
                {props.isNftpRoeEnabled && hasActuals && <td className="align-text-right" id="actual-cost">{formatValue(props.secondRow.actualValue)}</td>}
                <td/>
            </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td id="total-label" >{props.lastRow.label}</td>
                    <td id="total-count" className="align-text-right">
                        <span>
                            {showBreakdownLink
                                ? <button type="button" id="profitability-breakdown-link" className="link" onClick={() => setBreakdownVisible(true)}>{props.lastRow.value ? props.lastRow.value : convertToMonetary(estimatedTotal)}</button>
                                : (props.lastRow.value ? props.lastRow.value : convertToMonetary(estimatedTotal))}
                            {props.lastRow.value?'':getStatus(estimatedTotal)}
                        </span>
                    </td>
                    {props.isNftpRoeEnabled && hasActuals && 
                        <td id="actual-total" className="align-text-right">
                            <span>
                                {props.lastRow.value?props.lastRow.value:convertToMonetary(actualTotal)}
                                {props.lastRow.value?'':getStatus(actualTotal!)}
                            </span>
                        </td>
                    }
                </tr>
            </tfoot>
        </table>
    );

    if (!showBreakdownLink) {
        return table;
    }

    return (
        <>
            {table}
            <ProfitabilityBreakdownModal
                visible={isBreakdownVisible}
                breakdown={props.breakdown!}
                closeModal={() => setBreakdownVisible(false)}
            />
        </>
    )
}